import { render, staticRenderFns } from "./MaterialSignin.vue?vue&type=template&id=251c2dbe&scoped=true"
import script from "./MaterialSignin.vue?vue&type=script&lang=js"
export * from "./MaterialSignin.vue?vue&type=script&lang=js"
import style0 from "./MaterialSignin.vue?vue&type=style&index=0&id=251c2dbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251c2dbe",
  null
  
)

export default component.exports